import { render, staticRenderFns } from "./McLuckdraw.vue?vue&type=template&id=766f31ae&scoped=true&"
import script from "./McLuckdraw.vue?vue&type=script&lang=js&"
export * from "./McLuckdraw.vue?vue&type=script&lang=js&"
import style0 from "./McLuckdraw.vue?vue&type=style&index=0&id=766f31ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f31ae",
  null
  
)

export default component.exports